// Note: it can be transfered to the cms api also
export const USP_HIGHLIGHT_TITLES = [
  "On-Time Pick-up",
  "No Last Minute Cancellation",
];
